export default defineNuxtPlugin(async (nuxtApp) => {
    const w: any = window

    const loadHubspotScript = (portalId: string) =>
        new Promise<void>((resolve, reject) => {
            if (document.getElementById('hs-script-loader')) return resolve()

            const s = document.createElement('script')
            s.id = 'hs-script-loader'
            s.async = true
            s.defer = true
            s.src = `https://js.hs-scripts.com/${portalId}.js`
            s.onload = () => resolve()
            s.onerror = () => reject(new Error('Failed to load HubSpot script'))
            document.head.appendChild(s)
        })

    const route = nuxtApp.$router?.currentRoute?.value
    const orgSlug = route?.params?.org_slug as string | undefined

    const portalId = useRuntimeConfig().public.hubspotPortalId as string

    if (!portalId) return

    let email: string | undefined
    let token: string | undefined

    try {
        if (!orgSlug) throw new Error('org_slug missing')
        const res: any = await $fetch(`/api/${orgSlug}/hubspot-token`, {
            credentials: 'include',
        })

        email = res.email
        token = res.token
    } catch (e) {
    }

    w.hsConversationsSettings = {
        loadImmediately: false,
        ...(email && token
            ? { identificationEmail: email, identificationToken: token }
            : {}),
    }

    w.hsConversationsOnReady = w.hsConversationsOnReady || []
    w.hsConversationsOnReady.push(() => {
        w.HubSpotConversations?.widget?.load?.()
        w.HubSpotConversations?.widget?.close?.()
    })

    // The chat widget is non-essential — never let a failed load (ad blocker,
    // network, unreachable from local) crash app initialization.
    try {
        await loadHubspotScript(portalId)
    } catch (e) {
        console.warn('HubSpot chat widget failed to load:', e)
    }
})